import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react'; // @ts-expect-error convert to TS

import { makeEventRelay } from '../../core/EventRelay';
import memoizeOne from 'react-utils/memoizeOne';
import UIModalDialog from '../UIModalDialog';
import UIFullScreen from '../UIFullScreen'; // @ts-expect-error convert to TS

import getTransitionProps from './getTransitionProps';
import { SandboxContext } from '../../context/SandboxContext';
import { asHiddenProp } from '../../utils/asHiddenProp';
export default class AbstractModal extends Component {
  constructor(...args) {
    super(...args);
    this._closeStartRelay = makeEventRelay();
    this._openCompleteRelay = makeEventRelay();
    this._getTransitionProps = memoizeOne(getTransitionProps);
  }

  render() {
    const _this$props = this.props,
          {
      componentName,
      _contextual,
      ModalDialog = AbstractModal.defaultProps.ModalDialog,
      onOpenStart,
      onOpenComplete,
      onCloseStart,
      onCloseComplete,
      Transition,
      rootNode
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["componentName", "_contextual", "ModalDialog", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "Transition", "rootNode"]);

    const sandboxed = _contextual || this.context.sandboxed;

    const renderedModalDialog = /*#__PURE__*/_jsx(ModalDialog, Object.assign({}, rest, {
      contextual: _contextual === undefined ? _contextual : asHiddenProp(_contextual) // @ts-expect-error UIModalDialog props are incorrectly generated and should include the two props below
      ,
      _openCompleteRelay: sandboxed ? null : this._openCompleteRelay,
      _closeStartRelay: sandboxed ? null : this._closeStartRelay
    }));

    return sandboxed ? renderedModalDialog : /*#__PURE__*/_jsx(UIFullScreen, {
      "data-layer-for": componentName,
      rootNode: rootNode,
      Transition: Transition // @ts-expect-error UIFullScreen spreads transitionProps into UILayer
      ,
      transitionProps: this._getTransitionProps(onOpenStart, this._openCompleteRelay.getHandle(onOpenComplete), this._closeStartRelay.getHandle(onCloseStart), onCloseComplete),
      children: renderedModalDialog
    });
  }

}
AbstractModal.propTypes = {
  componentName: PropTypes.string.isRequired,
  _contextual: PropTypes.bool,
  ModalDialog: PropTypes.elementType.isRequired,
  onOpenStart: PropTypes.func,
  onOpenComplete: PropTypes.func,
  onCloseStart: PropTypes.func,
  onCloseComplete: PropTypes.func,
  rootNode: UIFullScreen.propTypes.rootNode,
  Transition: PropTypes.elementType
};
AbstractModal.contextType = SandboxContext;
const defaultProps = {
  ModalDialog: UIModalDialog
};
AbstractModal.defaultProps = defaultProps;
AbstractModal.displayName = 'AbstractModal';